import { createAction } from 'redux-actions';
import {
    SET_OPTION,
    SET_OPTIONLOADING
} from '../constants/actionTypes';
import { doGet, doPost } from '../utils/AjaxRequests'
import _ from 'lodash'
import { apiPrefixUrl } from '../utils/connection'
import { format, parse, isValid } from 'date-fns'
import {weeks} from '../utils/utils'
import {setFormValue} from './formAction'

export const setOption = createAction(SET_OPTION)
export const setOptionLoading = createAction(SET_OPTIONLOADING)

export const fetchInitialOptions = () => {
    return (dispatch, getState) => {

        doPost(apiPrefixUrl, {
            "api":"APCSchdTypesV2",
            "SPNO":"",
            "USER_ID":"patient"
        })
        .then((data)=>{
            let schdOptions = _.map(data.data, (item, key)=>{
                return {
                    value:item.SCHD_TYPE,
                    label:item.SCHD_TYPE_NAME,
                    description:item.DESCRIPTION,   
                    msg:item.MESSAGE,
                    // subOptions: item.OPTIONS,
                    isActive:item.IS_ACTIVE                 
                    // disabled:item.IS_ACTIVE
                }
            })

            dispatch(setOption({ field: 'schd_type', options: schdOptions }))
        })


        doPost(apiPrefixUrl, {
            api:'TWZip'
        })
        .then((data)=>{
            let cityOptions = _.map(data.data, (item, key)=>({value:item.City, label:item.City}))
            dispatch(setOption({ field: 'city', options: cityOptions }))
        })



       
    }
    
}

export const getConsultOptions=(schd_type)=>{
    return (dispatch, getState) => {
        doPost(apiPrefixUrl, {
            "api":"APCSchdTypesV2",            
            "SPNO":"",
            "USER_ID":"patient"
        })
        .then((data)=>{

            const opts = _.find(data.data, (o)=>o.SCHD_TYPE ===schd_type)

            let consultOptions = _.map(opts.CONSULT_OPTIONS, (item, key)=>{
                return {
                    value:item.CODE_NO,
                    label:item.CODE_NAME,
                    SCHD_OPTION_GROUP_ID: item.SCHD_OPTION_GROUP_ID
                    // description:item.DESCRIPTION,   
                    // msg:item.MESSAGE,
                    // subOptions: item.OPTIONS,
                    // isActive:item.IS_ACTIVE                 
                    // disabled:item.IS_ACTIVE
                }
            })

            dispatch(setOption({ field: 'consult', options: consultOptions }))

            let consultGroup = _.map(opts.CONSULT_GROUPS, (item, key)=>{
                return {
                    ...item,
                    OPTIONS: _.filter(consultOptions, o=>o.SCHD_OPTION_GROUP_ID === item.SCHD_OPTION_GROUP_ID)
                }
            })

            dispatch(setOption({ field: 'consultGroup', options: consultGroup }))
        })
    }
}


export const getSchdTimeOptions=(schd_type, consult)=>{
    return (dispatch, getState) => {

        if(!consult){
            dispatch(setOption({ field: 'schdTime', options: [] }))
            return
        }

        dispatch(setOptionLoading({loading:true}))
        doPost(apiPrefixUrl, {
            "api":"APCSchdsetsV2",
            "SCHD_TYPE":schd_type,
            "CONSULT_OPTIONS":consult,
            "SPNO":"",
            "USER_ID":"patient"
        })
        .then((data)=>{
            if(data.status){
                // dispatch(setFormValue({ field: "schdType", value: data.data.SCHD_TYPE }))
                // dispatch(setFormValue({ field: "schdTypeName", value: data.data.SCHD_TYPE_NAME }))

                let schdTimeOptions = _.map(data.data.SCHDSETS, (item, key)=>{

                    let dt = parse(`${item.START_DATE_STR} 00:00`, 'yyyy/MM/dd HH:mm',new Date())
                    // let isFull = parseInt(item.TOT_LIMIT) <= parseInt(item.APPOINTMENT_CNT)

                    return {
                        title: item.NOON_STR,
                        // title: `${item.NOON_STR}${isFull?`(滿)`:`-剩餘${item.TOT_LIMIT-item.APPOINTMENT_CNT}人`}`,
                        start:dt,
                        end: dt,
                        allDay: false,
                        SCHD_ID: item.SCHD_ID_STR,  
                        disabled: false,
                        TOKEN:item.TOKEN,
                        KEY:item.KEY,
                        NOON:item.NOON,
                        START_DATE:item.START_DATE,
                        // QUOTA: parseInt(item.TOT_LIMIT)-parseInt(item.APPOINTMENT_CNT)                    
                    }
                })
              
                // let schdTimeOptions = _.map(data.data.SCHDSETS, (item, key)=>{
                //     let dateStr =  `${item.START_DATE_STR} (${weeks[item.DAYS_STR]})`   
                //     let timeStr = item.START_TIME_STR
                //     let isFull = parseInt(item.TOT_LIMIT) <= parseInt(item.APPOINTMENT_CNT)
                //     return {
                //         value: item.SCHD_ID,
                //         label: `${dateStr} ${timeStr}-剩餘${item.TOT_LIMIT-item.APPOINTMENT_CNT}人${isFull?`(滿)`:""}`,
                //         token: item.TOKEN,
                //         disabled: isFull 
                //     }
                // })
                dispatch(setOption({ field: 'schdTime', options: schdTimeOptions }))
                dispatch(setOptionLoading({loading:false}))
            }
        })
    }
}

export const getAreaCode =()=>{
    return (dispatch, getState) => {
        const city = getState().getIn(["form", "city"])

        dispatch(setOption({ field: 'AREA_CODE', options: [] }))
        if(city){
            doPost(apiPrefixUrl, {
                api:'TWZip'
            })
            .then((data)=>{
                let cityArea = _.find(data.data, (o)=>(o.City === city))
                let areaCodeOptions = _.map(cityArea.Citys, (item, key)=>({label:item.District, value:item.ZipCode}))
                dispatch(setOption({ field: 'AREA_CODE', options: areaCodeOptions }))
            })
        }
    }
}




